module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_7005.00fb7c02.png";